export default function(str){
    var textareaEl=document.createElement('textarea');
    document.body.appendChild(textareaEl)
    textareaEl.value=str;
    textareaEl.select();
    if(document.execCommand('copy')){
       window.meaasgeAlert(this.$t('common.copySuccess'));
    }else{
        window.meaasgeAlert(this.$t('common.copyFail'));
    }
    document.body.removeChild(textareaEl)
    textareaEl=null;
}
